import React, { PropsWithChildren } from 'react';

import styles from './index.module.scss';

export const StatusBarContainer: React.FC<PropsWithChildren> = ({ children }) => {
	return (
		<div className={styles.statusBarRoot}>
			<div className={styles.statusBarContainer}>{children}</div>
		</div>
	);
};
